"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _config = _interopRequireDefault(require("config"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var features = ['websiteCss', 'seo', 'removeBranding', 'brandingPackage', 'appColors', 'customCode', 'whiteLabelDomain'];

var isBrandingFeature = function isBrandingFeature(feature) {
  if (feature) {
    return features.indexOf(feature) !== -1;
  } else {
    return false;
  }
};

var isFeatureEnabled = function isFeatureEnabled(feature) {
  if (_config.default !== null && _config.default !== void 0 && _config.default.features || _config.default !== null && _config.default !== void 0 && _config.default.ldFeatures) {
    if (isBrandingFeature(feature)) {
      var _config$ldFeatures, _config$ldFeatures2;

      return !!((_config$ldFeatures = _config.default.ldFeatures) !== null && _config$ldFeatures !== void 0 && _config$ldFeatures[feature] || (_config$ldFeatures2 = _config.default.ldFeatures) !== null && _config$ldFeatures2 !== void 0 && _config$ldFeatures2['brandingPackage']);
    } else {
      var _config$ldFeatures3, _config$features;

      if (((_config$ldFeatures3 = _config.default.ldFeatures) === null || _config$ldFeatures3 === void 0 ? void 0 : _config$ldFeatures3[feature]) !== undefined) {
        var _config$ldFeatures4;

        return !!((_config$ldFeatures4 = _config.default.ldFeatures) !== null && _config$ldFeatures4 !== void 0 && _config$ldFeatures4[feature]);
      }

      return !!((_config$features = _config.default.features) !== null && _config$features !== void 0 && _config$features[feature]);
    }
  } else {
    return false;
  }
};

var isMoreTabsFeatureEnabled = function isMoreTabsFeatureEnabled(created) {
  var DATE_TO_SUPPORT_MORE_TABS = 1557828000000; // '2019-05-14 10:00'

  var visibleMoreTabs = true;

  if (created < DATE_TO_SUPPORT_MORE_TABS) {
    visibleMoreTabs = !isFeatureEnabled('disableMoreTabs');
  }

  return visibleMoreTabs;
};

var featureToggleNames = function featureToggleNames(type) {
  var features = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fontFeatureNames = {
    'Gotham': 'Gotham',
    'Calibri': 'Calibri',
    'AvenirNext': 'Avenir Next',
    'Avenir-LT-Std': 'Avenir-LT-Std',
    'Bitstream-Futura-Lt-BT': 'Bitstream-Futura-Lt-BT',
    'Cinetype': 'Cinetype',
    'Graphik': 'Graphik',
    'Taz': 'Taz',
    'TitlingGothicCompressed': 'Titling Gothic Compressed',
    'LeagueGothic': 'League Gothic Compressed',
    'SEGFoco': 'SEGFoco',
    'AcuminProCondensed': 'Acumin Pro Condensed',
    'kievietFont': 'Kieviet Offc',
    'AdelleSans': 'Adelle Sans',
    'LinetoCircular': 'Lineto Circular',
    'GT-Pressura-Mono': 'GT Pressura Mono',
    'Bebas Neue': 'Bebas Neue',
    'Tungsten': 'Tungsten',
    'Neue-Hass-Grotesk': 'Neue-Hass-Grotesk',
    'Gilroy': 'Gilroy',
    'BarleyScript': 'BarleyScript',
    'PostazBold-Regular': 'PostazBold-Regular',
    'GoogleSans': 'Google-Sans',
    'Franklin-Gothic-Book': 'Franklin Gothic Book',
    'Franklin-Gothic-Demi': 'Franklin Gothic Demi',
    'Helvetica': 'Helvetica',
    'Locator': 'Locator',
    'OctoberMoon': 'October Moon',
    'CircularStd': 'Circular Std',
    'ProximaNova-CS': 'ProximaNova CS',
    'MyriadPro': 'MyriadPro',
    'MyriadPro-Semi-Condensed': 'MyriadPro-Semi-Condensed',
    'MyriadPro-Semi-Extended': 'MyriadPro-Semi-Extended',
    'LuxuryText': 'Luxury Text',
    'ArtegraSans': 'ArtegraSans',
    'ZingRustBase': 'Zing Rust Base',
    'ZingRustHalftone': 'Zing Rust Halftone',
    'ZingRustLine': 'Zing Rust Line',
    'Franklin-Gothic-CnSC-Book': 'Franklin Gothic CnSC Book',
    'Franklin-Gothic-CnSC-Medium': 'Franklin Gothic CnSC Medium',
    'Franklin-Gothic-Comp-Book': 'Franklin Gothic Comp Book',
    'FranklinGothic-Ext-Comp-Book': 'Franklin Gothic Ext Comp Book',
    'FranklinGothic-Cond-Book': 'Franklin Gothic Cond Book',
    'FranklinGothic-Cond-Demi': 'Franklin Gothic Cond Demi',
    'Roska': 'Roska',
    'Brandon Grotesque': 'Brandon Grotesque',
    'Alternate Gothic': 'Alternate Gothic',
    'DINPro': 'DIN Pro',
    'DirtyHeadline': 'Dirty Headline',
    'Novecentowide': 'Novecentowide',
    'Plantagenet-Cherokee': 'Plantagenet Cherokee',
    'Segoe-Ui': 'Segoe-Ui',
    'Futura': 'Futura',
    'Futura-Condensed': 'Futura-Condensed',
    'Segoe-Ui-Light': 'Segoe UI Light',
    'Segoe-Ui-SemiBold': 'Segoe UI SemiBold',
    'Segoe-Ui-SemiLight': 'Segoe UI SemiLight',
    'Fabrikat-Mono': 'Fabrikat Mono',
    'NexaSlab': 'Nexa Slab',
    'UniNeue': 'Uni Neue',
    'Gotham-Condensed': 'Gotham-Condensed',
    'Gotham-Rounded': 'Gotham-Rounded',
    'BureauGrotesque-Five': 'Bureau Grotesque Five',
    'BureauGrotesque-One': 'Bureau Grotesque One',
    'BureauGrotesque-Seven': 'Bureau Grotesque Seven',
    'BureauGrotesque-Three': 'Bureau Grotesque Three',
    'CompassSans': 'CompassSans',
    'CompassSerif': 'CompassSerif',
    'Helvetica-Neue': 'Helvetica Neue',
    'Helvetica-Neue-Outline': 'Helvetica Neue Outline',
    'Helvetica-Neue-Condensed': 'Helvetica Neue Condensed',
    'PostGrotesk': 'PostGrotesk',
    'AauxNext': 'Aaux Next',
    'Neuzeit-Office': 'Neuzeit Office',
    'EuclidFlex': 'Euclid Flex',
    'RingsideCondensed': 'Ringside Condensed',
    'BerninaSans': 'Bernina Sans',
    'BerninoSans': 'Bernino Sans',
    'NightMachine': 'Night Machine',
    'SGMT-PostGrotesk': 'SGMT Post Grotesk',
    'LaneCane_Regular': 'LaneCane Regular',
    'LaneNarrow_Regular': 'LaneNarrow Regular',
    'LanePosh_Regular': 'LanePosh Regular',
    'LaneUpper_Regular': 'LaneUpper Regular',
    'AvantGuard': 'AvantGuard',
    'CenturyGothic': 'Century Gothic',
    'BerlingskeSerifText': 'Berlingske Serif Text',
    'DrukCond-Super': 'DrukCond-Super',
    'DrukXCond-Super': 'DrukXCond Super',
    'Druk-Web': 'Druk Web',
    'DrukWide-Web': 'DrukWide Web',
    'AtlasTypewriter': 'Atlas Typewriter',
    'TiemposHeadline': 'Tiempos Headline',
    'TiemposText': 'Tiempos Text',
    'Geomanist': 'Geomanist',
    'Helvetica-Neue-Extended': 'Helvetica Neue Extended',
    'ChronicleHairline': 'Chronicle Hairline',
    'ChronicleDisp': 'Chronicle Display',
    'ChronicleDeck': 'Chronicle Deck',
    'LyonText': 'Lyon Text',
    'NoeText': 'Noe Text',
    'Dinamit': 'Dinamit',
    'Kompakt': 'Kompakt',
    'DIN-Condensed': 'DIN-Condensed',
    'ACaslonPro': 'Caslon Pro',
    'HaasGroteskDSPro': 'Haas Grotesk DS Pro',
    'MinionPro': 'Minion Pro',
    'Palatino': 'Palatino',
    'Pangram': 'Pangram',
    'SerifGothic': 'Serif Gothic',
    'ZapfDingbats': 'Zapf Dingbats',
    'Cinetype-Mono': 'Cinetype Mono',
    'Frutiger': 'Frutiger',
    'AvenirPro': 'Avenir Pro',
    'AkkuratPro': 'Akkurat Pro',
    'Apercu': 'Apercu',
    'ApercuMono': 'Apercu Mono',
    'National': 'National',
    'TiemposFine': 'Tiempos Fine',
    'Rakuten': 'Rakuten',
    'BentonSans': 'Benton Sans',
    'StagSans': 'Stag Sans',
    'Suisse': 'Suisse',
    'SuisseMono': 'Suisse Mono',
    'Georgia': 'Georgia',
    'GeorgiaItalic': 'Georgia Italic',
    'Ageo': 'Ageo',
    'KnockoutWelterweight': 'Knockout Welterweight',
    'KnockoutMiddleweight': 'Knockout Middleweight',
    'KnockoutCruiserweight': 'Knockout Cruiserweight',
    'KnockoutFeatherweight': 'Knockout Featherweight',
    'Glypha': 'Glypha',
    'SofiaPro': 'Sofia Pro',
    'MaquettePro': 'Maquette Pro',
    'Flood': 'Flood',
    'IvarText': 'Ivar Text',
    'Campton': 'Campton',
    'NeutraDisplay': 'Neutra Display',
    'NeutraText': 'Neutra Text',
    'TektonPro-Cond': 'Tekton Pro Condensed',
    'Relative': 'Relative',
    'Edo': 'Edo',
    'NimbusSans-Outline-Extended': 'Nimbus Sans Outline Extended',
    'NimbusSans-Condensed': 'Nimbus Sans Condensed',
    'NimbusSans-Initials': 'Nimbus Sans Initials',
    'NimbusSans-Outline': 'Nimbus Sans Outline',
    'NimbusSans-Regular': 'Nimbus Sans Regular',
    'NimbusSans-Extended': 'Nimbus Sans Extended',
    'NimbusSans-Light': 'Nimbus Sans Light',
    'Neue-Haas-Grotesk-Display': 'Neue Haas Grotesk Display',
    'Inter': 'Inter',
    'One-GT-Super-Display': 'One GT Super Display',
    'One-GT-Super-Text': 'One GT Super Text',
    'GintoNormal': 'Ginto Normal',
    'Colfax': 'Colfax',
    'NeoSans': 'Neo Sans',
    'NeoSansPro': 'Neo Sans Pro',
    'GroteskA': 'Scto Grotesk A',
    'GroteskB': 'Scto Grotesk B',
    'BreveDisplay': 'Breve Display',
    'GillSans': 'Gill Sans',
    'AcuminPro': 'Acumin Pro',
    'NeoSansStd': 'Neo Sans Std',
    'SalesforceSans': 'Salesforce Sans',
    'BMWTypeV2': 'BMW Type V2',
    'BergenMono': 'Bergen Mono',
    'AwesomeWebFont': 'Awesome Web Font',
    'MetaPro': 'Meta Pro',
    'GreyCliff': 'Grey Cliff',
    'TradeGothic': 'Trade Gothic',
    'Signatra': 'Signatra',
    'Stargaze': 'Stargaze',
    'StargazeStencil': 'Stargaze Stencil',
    'Ford-Antenna': 'Ford Antenna',
    'Ford-Antenna-Comp': 'Ford Antenna Comp',
    'Ford-Antenna-ExtraCond': 'Ford Antenna ExtraCond',
    'Ford-Antenna-Cond': 'Ford Antenna Cond',
    'VisbyCF': 'Visby CF',
    'GT-America-Regular': 'GT America Regular',
    'GT-America-Mono': 'GT America Mono',
    'Platform': 'Platform',
    'RobotoBlack': 'Roboto Black',
    'Folio-Std': 'Folio Std',
    'ZonaPro': 'Zona Pro',
    'OldPress': 'Old Press',
    'NorthPort': 'North Port',
    'KhakiStd': 'Khaki Std',
    'Eurostile': 'Eurostile',
    'FunctionPro-Stencil': 'Function Pro Stencil',
    'FunctionPro-Condensed': 'Function Pro Condensed',
    'FunctionPro': 'Function Pro',
    'FunctionCaps': 'Function Caps',
    'Hellix': 'Hellix',
    'Canela': 'Canela',
    'Titling-Gothic-Narrow': 'Titling Gothic Narrow',
    'Titling-Gothic-Normal': 'Titling Gothic Normal',
    'Titling-Gothic-Skyline': 'Titling Gothic Skyline',
    'Titling-Gothic-Wide': 'Titling Gothic Wide',
    'FarnhamText': 'Farnham Text',
    'Gingrich-Deck': 'Gingrich Deck',
    'Optima': 'Optima',
    'Gobold': 'Gobold',
    'Metric': 'Metric',
    'Whitney': 'Whitney',
    'Korolev': 'Korolev',
    'Mont': 'Mont',
    'VWHead': 'VW Head',
    'VWText': 'VW Text',
    'AvantGardeGothic': 'Avant Garde Gothic',
    'AmazonEmberCd': 'Amazon Ember Cd',
    'AmazonEmber': 'Amazon Ember',
    'AudiType': 'Audi Type',
    'AudiTypeExtended': 'Audi Type Extended'
  };
  var featureNames = {
    'hideBizzaboTerms': 'Hide Bizzabo Terms And Conditions',
    'admin': 'Admin',
    'progressTask': 'Progress Task',
    'deleteContact': 'Delete Contact',
    'pbi': 'Pay By Invoice',
    'advancedSearch': 'Advanced Search',
    'clone': 'Clone Event',
    'hotLeads': 'Hot Leads',
    'personalization': 'Personalization',
    'advancedSearchTickets': 'Advanced Search Tickets',
    'slack': 'Slack',
    'bitcoin': 'Bitcoin',
    'salesforce': 'Salesforce',
    'mailchimp': 'Mailchimp',
    'removeBranding': '[Only] Remove Bizzabo mentions',
    'mergeContact': 'Merge Contact',
    'rtl': 'Right to Left',
    'swapTickets': 'Swap Tickets',
    'goals': 'Goals',
    'hideAmericanExpressIcon': 'Hide American Express Icon',
    'swapWithMoney': 'Swap With Money',
    'newCommunity': 'New Community',
    'websiteCss': '[Only] Website Css',
    'newPollsUI': 'New Polls UI',
    'brandingPackage': '[Full] Branding Package',
    'seo': '[Only] SEO',
    'appColors': '[Only] App Colors',
    'whiteLabelDomain': '[Only] White Label Domain',
    'showRegistrationDashboard': 'Show Registration Dashboard',
    'showSubscription': 'Show Subscription Usage',
    'showRevenueDashboard': 'Show Revenue Dashboard',
    'showEmailMarketingDashboard': 'Show Email Marketing dashboard',
    'googleTagManager': 'Google Tag Manager',
    'apiKeys': 'Public API',
    'analyticsNew': 'New Analytics',
    'showAccessibilitySettings': 'Show Accessibility Settings Tab',
    'customCode': '[Only] Custom Code',
    'editPaymentCredentials': 'Show Edit Payment Credentials Button',
    'whiteLabelApp': 'White Label App - Only Navigation',
    'analyticsDashboard': 'Analytics Dashboard',
    'IHSCustomCountryLabel': 'IHS Custom Country Label'
  };
  return fontFeatureNames[type] ? {
    displayName: fontFeatureNames[type],
    font: true,
    name: type,
    value: features[type]
  } : featureNames[type] ? {
    displayName: featureNames[type],
    font: false,
    name: type,
    value: features[type]
  } : {
    displayName: type,
    font: false,
    name: type,
    value: features[type]
  };
};

var _default = {
  isBrandingFeature: isBrandingFeature,
  isFeatureEnabled: isFeatureEnabled,
  isMoreTabsFeatureEnabled: isMoreTabsFeatureEnabled,
  featureToggleNames: featureToggleNames
};
exports.default = _default;